import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

import type {
  BackButtonComponentConfig,
  FlowComponentRenderProps,
} from "../types";

const BackButtonBlock: React.FC<
  FlowComponentRenderProps<BackButtonComponentConfig>
> = ({ config, goBack }) => {
  const label = config.label?.trim() || "Back";

  return (
    <Button
      aria-label={label}
      onClick={() => goBack?.(config.targetScreenId)}
      size="small"
      startIcon={<ArrowBackIosNewRoundedIcon sx={{ fontSize: 16 }} />}
      sx={{
        alignSelf: "flex-start",
        color: "var(--cx-brand-text)",
        fontWeight: 700,
        minWidth: 0,
        ml: -1,
        px: 1,
        py: 0.5,
        textTransform: "none",
        "&:hover": { bgcolor: "var(--cx-brand-button-hover-bg)" },
      }}
      type="button"
      variant="text"
    >
      <Box component="span" sx={{ lineHeight: 1.4 }}>
        {label}
      </Box>
    </Button>
  );
};

export default BackButtonBlock;
